
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface AuthErrorProps {
  onTryAgain?: () => void;
}

export function AuthError({ onTryAgain }: AuthErrorProps) {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    if (onTryAgain) {
      onTryAgain();
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[70vh]">
      <AlertTriangle className="h-16 w-16 text-amber-500 mb-6" />
      <h2 className="text-2xl font-bold mb-2">Erro de Autenticação</h2>
      <p className="text-center text-muted-foreground mb-6 max-w-md">
        Não foi possível acessar esta página. Por favor, verifique se você 
        está autenticado ou tente fazer login novamente.
      </p>
      <Button onClick={handleTryAgain} className="mb-3">
        Tentar Novamente
      </Button>
    </div>
  );
}
